export default "__VITE_ASSET__CsbMU3fU__"